import { createComponent } from '@carvana/merch-components';

export const Fallback = createComponent('div', {
  className: 'h-full w-full bg-background-weak'
});
